import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  ContratoAssessorEdit,
} from '../..';
import {
  allContratoAssessorEditEtapas,
  allContratoEntePrivadoEditEtapas,
  allContratoEntePublicoEditEtapas,
} from '../../../../library/ContratoEditEtapas';
import {
  CONTRATO_TIPO_ASSESSOR_NAME,
  CONTRATO_TIPO_ASSESSOR_DESCENTRALIZADO_NAME,
  CONTRATO_TIPO_ENTE_PUBLICO_DESCENTRALIZADO_NAME,
  CONTRATO_TIPO_ENTE_PRIVADO_NAME,
  CONTRATO_TIPO_ENTE_PUBLICO_NAME,
  CONTRATO_TIPO_ASSESSOR,
  CONTRATO_TIPO_ENTE_PUBLICO,
  CONTRATO_TIPO_ENTE_PRIVADO,
  CONTRATO_TIPO_ENTE_PRIVADO_DESCENTRALIZADO_NAME,
} from '../../../../library/ContratoTipos';
import {
  CONTRATO_VERSAO_ADITIVO,
  CONTRATO_VERSAO_ADITIVO_NAME,
  CONTRATO_VERSAO_CONTRATO,
  CONTRATO_VERSAO_CONTRATO_NAME,
  CONTRATO_VERSAO_DISTRATO,
  CONTRATO_VERSAO_DISTRATO_NAME,
} from '../../../../library/ContratoVersoes';
import {
  contratoAditivoEditRoute,
  contratoAditivoNovoRoute,
  contratoDistratoEditRoute,
  contratoDistratoNovoRoute,
  contratoEditRoute,
  contratoNovoRoute,
} from '../../../../library/Routes';
import ContratoEntePublicoEdit from '../FluxoCentralizados/ContratoEntePublicoEdit/ContratoEntePublicoEdit';
import ContratoEntePrivadoEdit from '../FluxoCentralizados/ContratoEntePrivadoEdit/ContratoEntePrivadoEdit';
import { getContratoTipoByRouteParams } from '../../../../utils/ContratoUtils';
import moment from 'moment';
import { Error404 } from '../../../Errors';
import { FluxoContratosDescentralizados } from '../FluxoDescentralizados';

class ContratoEdit extends Component {
  getTipoByProps = () => {
    const tipo =
      this.props.match.params.tipoContrato || CONTRATO_TIPO_ASSESSOR_NAME;
    switch (tipo.toLowerCase()) {
      case CONTRATO_TIPO_ASSESSOR_NAME:
        return CONTRATO_TIPO_ASSESSOR_NAME;
      case CONTRATO_TIPO_ENTE_PUBLICO_NAME:
        return CONTRATO_TIPO_ENTE_PUBLICO_NAME;
      case CONTRATO_TIPO_ENTE_PRIVADO_NAME:
        return CONTRATO_TIPO_ENTE_PRIVADO_NAME;
      case CONTRATO_TIPO_ASSESSOR_DESCENTRALIZADO_NAME:
        return CONTRATO_TIPO_ASSESSOR_DESCENTRALIZADO_NAME;
      case CONTRATO_TIPO_ENTE_PRIVADO_DESCENTRALIZADO_NAME:
        return CONTRATO_TIPO_ENTE_PRIVADO_DESCENTRALIZADO_NAME;
      case CONTRATO_TIPO_ENTE_PUBLICO_DESCENTRALIZADO_NAME:
        return CONTRATO_TIPO_ENTE_PUBLICO_DESCENTRALIZADO_NAME;
      default:
        return null;
    }
  };

  getPassoByProps = () => {
    return this.props.match.params.passo || null;
  };

  getTipoNumberByProps = () => {
    const tipo =
      this.props.match.params.tipoContrato || CONTRATO_TIPO_ASSESSOR_NAME;
    switch (tipo.toLowerCase()) {
      case CONTRATO_TIPO_ASSESSOR_NAME:
        return CONTRATO_TIPO_ASSESSOR;
      case CONTRATO_TIPO_ENTE_PUBLICO_NAME:
        return CONTRATO_TIPO_ENTE_PUBLICO;
      case CONTRATO_TIPO_ENTE_PRIVADO_NAME:
        return CONTRATO_TIPO_ENTE_PRIVADO;
      default:
        return null;
    }
  };

  getVersaoNumberByProps = () => {
    switch (this.props.match.path) {
      case contratoAditivoNovoRoute.path:
      case contratoAditivoEditRoute.path:
        return CONTRATO_VERSAO_ADITIVO;
      case contratoDistratoNovoRoute.path:
      case contratoDistratoEditRoute.path:
        return CONTRATO_VERSAO_DISTRATO;
      case contratoNovoRoute.path:
      case contratoEditRoute.path:
      default:
        return CONTRATO_VERSAO_CONTRATO;
    }
  };

  getVersaoByProps = () => {
    switch (this.props.match.path) {
      case contratoAditivoNovoRoute.path:
      case contratoAditivoEditRoute.path:
        return CONTRATO_VERSAO_ADITIVO_NAME;
      case contratoDistratoNovoRoute.path:
      case contratoDistratoEditRoute.path:
        return CONTRATO_VERSAO_DISTRATO_NAME;
      case contratoNovoRoute.path:
      case contratoEditRoute.path:
      default:
        return CONTRATO_VERSAO_CONTRATO_NAME;
    }
  };

  getVersaoLabelByVersaoNumber = (number) => {
    switch (number) {
      case CONTRATO_VERSAO_ADITIVO:
        return this.getVersaoLabelByVersaoName(CONTRATO_VERSAO_ADITIVO_NAME);
      case CONTRATO_VERSAO_DISTRATO:
        return this.getVersaoLabelByVersaoName(CONTRATO_VERSAO_DISTRATO_NAME);
      case CONTRATO_VERSAO_CONTRATO:
      default:
        return this.getVersaoLabelByVersaoName(CONTRATO_VERSAO_CONTRATO_NAME);
    }
  };

  getVersaoLabelByVersaoName = (name) => {
    return this.props.languageValues.contratos[name].name;
  };

  getVersaoLabelByProps = () => {
    return this.getVersaoLabelByVersaoName(this.getVersaoByProps());
  };

  getIdContratoByProps = () => {
    return this.props.match.params &&
      this.props.match.params.idContrato &&
      !isNaN(this.props.match.params.idContrato)
      ? this.props.match.params.idContrato
      : null;
  };

  getIdAditivoByProps = () => {
    return this.props.match.params &&
      this.props.match.params.idAditivo &&
      !isNaN(this.props.match.params.idAditivo)
      ? this.props.match.params.idAditivo
      : null;
  };

  getIdDistratoByProps = () => {
    return this.props.match.params &&
      this.props.match.params.idDistrato &&
      !isNaN(this.props.match.params.idDistrato)
      ? this.props.match.params.idDistrato
      : null;
  };

  getEtapaByProps = () => {
    const etapa = this.props.match.params.etapa;
    switch (this.getTipoByProps().toLowerCase()) {
      case CONTRATO_TIPO_ASSESSOR_NAME.toLowerCase():
        return etapa && allContratoAssessorEditEtapas.indexOf(etapa) > -1
          ? etapa
          : allContratoAssessorEditEtapas[0];
      case CONTRATO_TIPO_ENTE_PUBLICO_NAME.toLowerCase():
        return etapa && allContratoEntePublicoEditEtapas.indexOf(etapa) > -1
          ? etapa
          : allContratoEntePublicoEditEtapas[0];
      case CONTRATO_TIPO_ENTE_PRIVADO_NAME.toLowerCase():
        return etapa && allContratoEntePrivadoEditEtapas.indexOf(etapa) > -1
          ? etapa
          : allContratoEntePrivadoEditEtapas[0];
      default:
        return null;
    }
  };

  editing = () => {
    const versao = this.getVersaoByProps();
    switch (versao) {
      case CONTRATO_VERSAO_ADITIVO_NAME:
        return this.getIdAditivoByProps() ? true : false;
      case CONTRATO_VERSAO_DISTRATO_NAME:
        return this.getIdDistratoByProps() ? true : false;
      default:
        return this.getIdContratoByProps() ? true : false;
    }
  };

  toStep = (step, options) => {
    const idContrato = this.getIdContratoByProps();
    const idAditivo = this.getIdAditivoByProps();
    const idDistrato = this.getIdDistratoByProps();
    const matchParams = this.props.match.params;
    const newContrato = options && options.newContrato;
    const editContrato = options && options.editContrato;
    const newAditivo = options && options.newAditivo;
    const editAditivo = options && options.editAditivo;
    const newDistrato = options && options.newDistrato;
    const editDistrato = options && options.editDistrato;
    let path;
    if (this.editing()) {
      switch (this.getVersaoByProps()) {
        case CONTRATO_VERSAO_ADITIVO_NAME:
          if (editAditivo) {
            path = contratoAditivoEditRoute.getURLWithParams(
              getContratoTipoByRouteParams(matchParams),
              idContrato,
              idAditivo,
              step
            );
          }
          break;
        case CONTRATO_VERSAO_DISTRATO_NAME:
          if (editDistrato) {
            path = contratoDistratoEditRoute.getURLWithParams(
              getContratoTipoByRouteParams(matchParams),
              idContrato,
              idDistrato,
              step
            );
          }
          break;
        default:
          if (editContrato) {
            path = contratoEditRoute.getURLWithParams(
              getContratoTipoByRouteParams(matchParams),
              idContrato,
              step
            );
          }
      }
    } else {
      switch (this.getVersaoByProps()) {
        case CONTRATO_VERSAO_ADITIVO_NAME:
          if (newAditivo) {
            path = contratoAditivoNovoRoute.getURLWithParams(
              getContratoTipoByRouteParams(matchParams),
              idContrato,
              step
            );
          }
          break;
        case CONTRATO_VERSAO_DISTRATO_NAME:
          if (newDistrato) {
            path = contratoDistratoNovoRoute.getURLWithParams(
              getContratoTipoByRouteParams(matchParams),
              idContrato,
              step
            );
          }
          break;
        default:
          if (newContrato) {
            path = contratoNovoRoute.getURLWithParams(
              getContratoTipoByRouteParams(matchParams),
              step
            );
          }
      }
    }
    if (path) {
      this.goToPath(path);
    }
    return true;
  };

  goToPath = (path) => {
    this.props.history.push(path);
  };

  getIdOfVersao = () => {
    switch (this.getVersaoByProps()) {
      case CONTRATO_VERSAO_ADITIVO_NAME:
        return this.getIdAditivoByProps();
      case CONTRATO_VERSAO_DISTRATO_NAME:
        return this.getIdDistratoByProps();
      case CONTRATO_VERSAO_CONTRATO_NAME:
      default:
        return this.getIdContratoByProps();
    }
  };

  getContratoPrefixFileName = () => {
    const tipo = this.getTipoByProps();
    let versao = '';
    switch (this.getVersaoByProps()) {
      case CONTRATO_VERSAO_ADITIVO:
        versao = CONTRATO_VERSAO_ADITIVO_NAME;
        break;
      case CONTRATO_VERSAO_DISTRATO:
        versao = CONTRATO_VERSAO_DISTRATO_NAME;
        break;
      case CONTRATO_VERSAO_CONTRATO:
      default:
        versao = CONTRATO_VERSAO_CONTRATO_NAME;
        break;
    }
    return tipo + '-' + versao;
  };

  getDateStrToFileName = (date, dateFormatFrom) => {
    if (typeof date === 'string' && typeof dateFormatFrom === 'string') {
      return moment(date, dateFormatFrom).format('DD-MM-YYYY');
    }
    return moment().format('DD-MM-YYYY');
  };

  getContratoValidacaoFileName = (date, dateFormatFrom) => {
    return (
      this.getContratoPrefixFileName() +
      '-rascunho-data-' +
      this.getDateStrToFileName(date, dateFormatFrom)
    );
  };

  getContratoNaoAssinadoFileName = (date, dateFormatFrom) => {
    return (
      this.getContratoPrefixFileName() +
      '-data-' +
      this.getDateStrToFileName(date, dateFormatFrom)
    );
  };

  getContratoAssinadoFileName = (date, dateFormatFrom) => {
    return (
      this.getContratoPrefixFileName() +
      '-data-' +
      this.getDateStrToFileName(date, dateFormatFrom)
    );
  };

  getContratoExtratoFileName = (date, dateFormatFrom) => {
    return (
      this.getContratoPrefixFileName() +
      '-extrato-data-' +
      this.getDateStrToFileName(date, dateFormatFrom)
    );
  };

  getContratoPlanoTrabalhoFileName = (date, dateFormatFrom) => {
    return (
      this.getContratoPrefixFileName() +
      '-plano-trabalho-data-' +
      this.getDateStrToFileName(date, dateFormatFrom)
    );
  };

  getContratoRevisaoFileName = (date, dateFormatFrom) => {
    return (
      this.getContratoPrefixFileName() +
      '-revisao-data-' +
      this.getDateStrToFileName(date, dateFormatFrom)
    );
  };

  getDocumentoPreloaderMessage = () => {
    switch (this.getVersaoNumberByProps()) {
      case CONTRATO_VERSAO_ADITIVO:
        return this.props.languageValues.loadingAditivo;
      case CONTRATO_VERSAO_DISTRATO:
        return this.props.languageValues.loadingDistrato;
      case CONTRATO_VERSAO_CONTRATO:
      default:
        return this.props.languageValues.loadingContrato;
    }
  };

  render() {
    const props = {
      ...this.props,
      utils: {
        getTipoByProps: this.getTipoByProps,
        getTipoNumberByProps: this.getTipoNumberByProps,
        getVersaoNumberByProps: this.getVersaoNumberByProps,
        getVersaoByProps: this.getVersaoByProps,
        getVersaoLabelByVersaoNumber: this.getVersaoLabelByVersaoNumber,
        getVersaoLabelByVersaoName: this.getVersaoLabelByVersaoName,
        getVersaoLabelByProps: this.getVersaoLabelByProps,
        getIdContratoByProps: this.getIdContratoByProps,
        getIdAditivoByProps: this.getIdAditivoByProps,
        getIdDistratoByProps: this.getIdDistratoByProps,
        getEtapaByProps: this.getEtapaByProps,
        editing: this.editing,
        toStep: this.toStep,
        goToPath: this.goToPath,
        getIdOfVersao: this.getIdOfVersao,
        getContratoPrefixFileName: this.getContratoPrefixFileName,
        getContratoValidacaoFileName: this.getContratoValidacaoFileName,
        getContratoNaoAssinadoFileName: this.getContratoNaoAssinadoFileName,
        getContratoAssinadoFileName: this.getContratoAssinadoFileName,
        getContratoExtratoFileName: this.getContratoExtratoFileName,
        getContratoPlanoTrabalhoFileName: this.getContratoPlanoTrabalhoFileName,
        getContratoRevisaoFileName: this.getContratoRevisaoFileName,
        getDocumentoPreloaderMessage: this.getDocumentoPreloaderMessage,
      },
    };

    switch ((this.getTipoByProps() || '').toLowerCase()) {
      case CONTRATO_TIPO_ASSESSOR_NAME.toLowerCase():
        return <ContratoAssessorEdit {...props} />;
      case CONTRATO_TIPO_ENTE_PUBLICO_NAME.toLowerCase():
        return <ContratoEntePublicoEdit {...props} />;
      case CONTRATO_TIPO_ENTE_PRIVADO_NAME.toLocaleLowerCase():
        return <ContratoEntePrivadoEdit {...props} />;
      case CONTRATO_TIPO_ASSESSOR_DESCENTRALIZADO_NAME.toLowerCase():
        return <FluxoContratosDescentralizados {...props} />;
      case CONTRATO_TIPO_ENTE_PUBLICO_DESCENTRALIZADO_NAME.toLowerCase():
        return <FluxoContratosDescentralizados {...props} />
      case CONTRATO_TIPO_ENTE_PRIVADO_DESCENTRALIZADO_NAME.toLowerCase():
        return <FluxoContratosDescentralizados {...props} />;
      default:
        return <Error404 />;
    }
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  auth: state.auth,
});

export default connect(mapStateToProps)(withRouter(ContratoEdit));
